
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.879 15.879"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_32382","data-name":"Path 32382","d":"M11.65 1.898a7.139 7.139 0 012.33 2.33m-2.33-2.33l-2.716 3.26m2.716-3.26a7.1 7.1 0 00-7.423 0m9.753 2.33l-3.26 2.716m3.26-2.716a7.1 7.1 0 010 7.423m-3.26-4.707a2.961 2.961 0 00-1.787-1.787m1.787 1.787a2.966 2.966 0 010 1.991M8.935 5.157a2.966 2.966 0 00-1.991 0m3.778 3.778a2.961 2.961 0 01-1.787 1.787m1.787-1.787l3.26 2.716m0 0a7.139 7.139 0 01-2.33 2.33m0 0l-2.716-3.26m2.716 3.26a7.1 7.1 0 01-7.423 0m4.707-3.26a2.966 2.966 0 01-1.991 0m0 0a2.961 2.961 0 01-1.787-1.787m1.787 1.787l-2.716 3.26m0 0a7.139 7.139 0 01-2.33-2.33m0 0l3.26-2.716M1.898 11.65a7.1 7.1 0 010-7.423m3.26 4.707a2.966 2.966 0 010-1.991m0 0a2.961 2.961 0 011.786-1.786M5.157 6.944L1.898 4.228m5.046.929L4.228 1.898m0 0a7.139 7.139 0 00-2.33 2.33","fill":"none","stroke":"#6964eb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    